(function () {
  var controllerId = "reportController";
  var pageTitle = " Reports | PC*MILER Web";
  angular
    .module("reportApp")
    .controller(controllerId, ["$rootScope", "$scope", "$window", "$sce", "$filter", "_", "optionsUI", "UserProvider", "mapService", "$timeout",
      function reportController($rootScope, $scope, $window, $sce, $filter, _, optionsUI, userProvider, mapService, $timeout) {
        ALKMaps.APIKey = "token=" + userProvider.getUser().authToken;
        $scope.isLoading = true;
        $scope.region = userProvider.getUser().region;
        $scope.subscriptionLevel = userProvider.getUser().subscriptionLevel;

        var queryString = (function () {
          var queryString = $window.location.search.substring(1);
          var params = {},
            queries, temp, i, l;

          // Split into key/value pairs
          queries = queryString.split("&");
          // Convert the array of strings into an object
          for (i = 0, l = queries.length; i < l; i++) {
            temp = queries[i].split("=");
            params[temp[0]] = temp[1];
          }
          return params;
        })();

        $scope.id = queryString.id;
        $scope.route = $window.opener.angular.element("#route-panel").scope().routeVm.getRoute($scope.id);

        var updateReport = function (event, message) {
          if (message === $scope.id) {
            $scope.route = $window.opener.angular.element("#route-panel").scope().routeVm.getRoute($scope.id);
            $scope.init();
          }
        };

        var updateReportListener = $window.opener.angular.element("#route-panel").scope().$on("UpdateReport", updateReport);

        $window.onbeforeunload = function () {
          updateReportListener();
        };

        $scope.showAllForPrint = false;

        $scope.printOne = function () {
          $scope.showAllForPrint = false;
          setTimeout(function () { //do not change this to $setTimeout since it stays inside the scope
            $window.print();
          }, 10);

        };

        $scope.printAll = function () {
          $scope.showAllForPrint = true;
          setTimeout(function () { //do not change this to $setTimeout since it stays inside the scope
            $window.print();
          }, 10);
        };

        $scope.isCurrentData = function () {
          return ($scope.route.options.dataVersion === "current" || $scope.route.options.dataVersion === "PCM_EU");
        };
        $scope.dataVersionStr = function () {
          if (userProvider.getUser().region === "EU") {
            return "PCM_EU";
          }
          return _.find(optionsUI.reportDataVersion, {
            value: $scope.route.options.dataVersion
          }).display;
        };
        $scope.tollCurrencyStr = function () {
          return _.find(optionsUI.tollCurrencyEU, {
            value: $scope.route.options.tollCurrency
          }).display;
        };
        $scope.distanceUnit = function () {
          return ($scope.route.options.distanceUnits === 0) ? "Miles" : "KMs";
        };
        $scope.distanceUnitAbbr = function () {
          return ($scope.route.options.distanceUnits === 0) ? "mi" : "km";
        };

        $scope.postReports = function () {

          var rptType = "";

          if (userProvider.getUser().region === "EU") {
            rptType = $scope.subscriptionLevel === "Premium" ? "Mileage,Directions,Detail,State,Road,TollDetail" : "Mileage,Directions,Detail,State,Road";
            _.extend($scope.route.options, {
              region: "EU"
            });
          } else {
            rptType = "Mileage,Directions,Detail,State,Road";
          }

          var reportPromise = mapService.addReportPromise($scope.route.id, $scope.route.stops, $scope.route.options, $scope.route.uiArrDepSelection, rptType);

          var getSpecificResponse = function (resp, keyword) {
            return _.filter(resp, res => {
              return res["__type"].indexOf(keyword) === 0;
            });
          };

          reportPromise.then(function (resp) {
            var temp = [];
            // process report and generate HTML if there is any
            temp = getSpecificResponse(resp, "Mileage");
            if (temp.length > 0) {
              $scope.processMileage(temp[0]);
            }
            temp = getSpecificResponse(resp, "Directions");
            if (temp.length > 0) {
              $scope.processDirections(temp[0]);
            }
            temp = getSpecificResponse(resp, "Detail");
            if (temp.length > 0) {
              $scope.processDetails(temp[0]);
            }
            temp = getSpecificResponse(resp, "State");
            if (temp.length > 0) {
              $scope.processStateMileage(temp[0]);
            }
            temp = getSpecificResponse(resp, "Road");
            if (temp.length > 0) {
              $scope.processRoadTypes(temp[0]);
            }
            temp = getSpecificResponse(resp, "TollDetail");
            if (temp.length > 0) {
              $scope.processTollDetail(temp[0]);
            }
            $scope.isLoading = false;
            $timeout(function () {
              $scope.$apply();
            },10);
          }, function (err) {
            console.log(err);
          });
        };

        $scope.init = function () {
          $scope.postReports();
          $rootScope.pageTitle = $scope.route.name + pageTitle;
        };

        var wrapCell = function (str, cssclass, span) {
          var classStr = (typeof (cssclass) === "undefined" || cssclass === "") ? "" : " class='" + cssclass + "'";
          var spanStr = (typeof (span) === "undefined" || span === "") ? "" : " colspan='" + span + "'";
          if (str === null) {
            str = "";
          }
          return "<td" + classStr + spanStr + ">" + str + "</td>";
        };

        var latlonOnly = function(stop) {
          if(stop.origLatlon){
            return true
          } else if (stop.Address.City === "" && stop.Address.Country === "" && stop.Address.County === "" && stop.Address.State === "" && stop.Address.StreetAddress === "") {
            return true;
          } else {
            return false
          };
        };

        var fullAddress = function (data) {
          var addrStr = "";
          if (data) {
            if (latlonOnly(data)) {
              addrStr = "Lon: " + data.Coords.Lon + ", Lat: " + data.Coords.Lat;
            } else {
              if (data.Address.StreetAddress !== null && data.Address.StreetAddress !== "") {
                addrStr += data.Address.StreetAddress + ", ";
              }
              if (data.Address.City !== null && data.Address.City !== "") {
                addrStr += data.Address.City + ", ";
              }
              if (data.Address.State !== null && data.Address.State !== "") {
                addrStr += data.Address.State + " ";
              }
              if (data.Address.Zip !== null && data.Address.Zip !== "") {
                addrStr += data.Address.Zip + " ";
              }
              if (data.Address.Country !== null && data.Address.Country !== "") {
                addrStr += ", " + data.Address.Country;
              }
            }
          }
          return addrStr;
        };

        $scope.routeODInfo = function () {
          var infoStr = "";
          var numStops = $scope.route.stops.length;

          if (latlonOnly($scope.route.stops[0])) {
            infoStr += "Lon: " + $scope.route.stops[0].Coords.Lon + ", Lat: " + $scope.route.stops[0].Coords.Lat;
          } else {
            infoStr += $scope.route.stops[0].CityStateZip;
          }

          if (latlonOnly($scope.route.stops[numStops - 1])) {
            infoStr += " to " + "Lon: " + $scope.route.stops[numStops - 1].Coords.Lon + ", Lat: " + $scope.route.stops[numStops - 1].Coords.Lat;
          } else {
            infoStr += " to " + $scope.route.stops[numStops - 1].CityStateZip;
          }

          infoStr += " : " + ((numStops === 2) ? "No " : numStops - 2) + " Stop" + ((numStops === 3) ? "" : "s");
          return infoStr;
        };

        $scope.detailsHTML = "";
        $scope.directionsHTML = "";
        $scope.stateTopHTML = "";
        $scope.stateListHTML = "";
        $scope.roadTypeHTML = "";
        $scope.tollDetailSegmentHTML = "";
        $scope.tollDetailSummaryHTML = "";

        $scope.processMileage = function (json) {
          var l = json.ReportLines.length - 1;

          $scope.route.routeDistance = json.ReportLines[l].TMiles + " " + $scope.distanceUnitAbbr();
          $scope.route.routeTMiles = json.ReportLines[l].TMiles;
          var timeArr = json.ReportLines[l].THours.split(":");
          var timeStr = "";
          if (parseInt(timeArr[0]) === 0) {
            timeStr = timeArr[1] + " min.";
          } else {
            timeStr = timeArr[0] + " hr. " + timeArr[1] + " min.";
          }
          $scope.route.routeTime = timeStr;
          $scope.route.routeTHours = json.ReportLines[l].THours;
          $scope.route.routeTTolls = json.ReportLines[l].TTolls;
          $scope.route.routeTCost = json.ReportLines[l].TCostMile;
        };

        $scope.processDetails = function (json) {
          json = json.ReportLegs;
          var detailOutput = "";
          var stopCount = 0;
          if (json.length > 0) {
            for (var l = 0; l < json.length; l++) { // each route leg
              for (var i = 0; i < json[l].ReportLines.length; i++) { //each line of the report
                var thisLine = json[l].ReportLines[i];
                var etaCell = ($scope.route.hasTime) ? wrapCell(thisLine.EtaEtd, "numeric") : "";
                var hazmatCell = ($scope.route.options.hazMatType) ? wrapCell(thisLine.Restriction, "numeric") : "";
                var TtollCell = ($scope.route.options.inclTollData) ?
                  (wrapCell(thisLine.TToll != null ? $filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(thisLine.TToll, 2) : "", "numeric") + "<td></td>") : "";
                var LtollCell = ($scope.route.options.inclTollData) ?
                  wrapCell((thisLine.LToll !== "0.00") ? $filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(thisLine.LToll, 2) : "--", "numeric") : "";
                var PlazaCell = ($scope.route.options.inclTollData) ? wrapCell(thisLine.TollPlazaAbbr, "numeric") : "";
                if (thisLine.Stop !== null) { //origin or destination
                  var stopStr = fullAddress($scope.route.stops[stopCount]);
                  stopCount++;
                  detailOutput += "<tr class='detail-orig-dest'>" +
                    wrapCell(stopStr, "long-text", 4) +
                    wrapCell(thisLine.Time, "numeric") +
                    wrapCell(thisLine.InterCh, "long-text") +
                    wrapCell($filter("number")(thisLine.LMiles, 1), "numeric") +
                    wrapCell(thisLine.LTime, "numeric") +
                    wrapCell($filter("number")(thisLine.TMiles, 1), "numeric") +
                    wrapCell(thisLine.TTime, "numeric") +
                    TtollCell + etaCell + hazmatCell +
                    "</tr>";
                } else if (thisLine.ArState !== null) { //Arrival text
                  var colSpan = 13;
                  if (!$scope.route.hasTime) {
                    colSpan -= 1
                  };
                  if (!$scope.route.inclTollData) {
                    colSpan -= 2
                  };
                  detailOutput += "<tr class='detail-orig-dest'>" +
                    wrapCell(thisLine.ArState, "", colSpan) + "</tr>";
                } else if (thisLine.Warn !== null) { //Arrival text
                  var colSpan = 13;
                  if (!$scope.route.hasTime) {
                    colSpan -= 1
                  };
                  if (!$scope.route.inclTollData) {
                    colSpan -= 2
                  };
                  detailOutput += "<tr class='detail-warning'>" +
                    wrapCell(thisLine.Warn, "", colSpan) + "</tr>";
                } else {
                  detailOutput += "<tr class='detail-line'>" +
                    wrapCell(thisLine.State) +
                    wrapCell((thisLine.LToll !== null && thisLine.LToll !== "0.00") ? $filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) : "") +
                    wrapCell(thisLine.Route, "long-text") +
                    wrapCell($filter("number")(thisLine.Miles, 1), "numeric") +
                    wrapCell(thisLine.Time, "numeric") +
                    wrapCell(thisLine.InterCh, "long-text") +
                    wrapCell($filter("number")(thisLine.LMiles, 1), "numeric") +
                    wrapCell(thisLine.LTime, "numeric") +
                    wrapCell($filter("number")(thisLine.TMiles, 1), "numeric") +
                    wrapCell(thisLine.TTime, "numeric") +
                    LtollCell +
                    PlazaCell +
                    etaCell + hazmatCell + "</tr>";
                }
              }
            }
          }
          $scope.detailsHTML = $sce.trustAsHtml(detailOutput);
        };

        $scope.processDirections = function (json) {
          //console.log(json);
          json = json.ReportLegs;
          var dirOutput = "";
          if (json.length > 0) {
            for (var l = 0; l < json.length; l++) {
              var reportArr = json[l];
              for (var i = 0; i < reportArr.ReportLines.length; i++) {
                var line = reportArr.ReportLines[i];
                var dirStr = "";
                if (i === 0) {
                  dirOutput += "<li class=\"direction-item line-" + i + "\">" + fullAddress($scope.route.stops[l]) +
                    "<span class=\"stat dist\">" + $scope.distanceUnit() + "</span>" +
                    "<span class=\"stat time\">Hr:Min</span>" +
                    "</li>";
                } else if (l === json.length - 1 && i === reportArr.ReportLines.length - 7) {
                  dirStr = fullAddress($scope.route.stops[$scope.route.stops.length - 1]);
                  dirOutput += "<li class=\"direction-item sub-direction destination-total\">" + dirStr +
                    "<span class=\"stat dist\">" + $filter("number")(line.Dist, 1) + "</span>" +
                    "<span class=\"stat time\">" + line.Time + "</span>" +
                    "</li>";
                } else if (l === json.length - 1 && i >= reportArr.ReportLines.length - 6) {
                  dirStr = line.Direction;
                  dirOutput += "<li class=\"direction-item disclaimer\">" + dirStr + "</li>";
                } else {
                  var dirClass = ""
                  if (line.Direction !== null) {
                    dirStr = line.Direction;
                  } else {
                    dirStr = line.Warn;
                  }
                  var warnTest = /(Warning)/i;
                  if (warnTest.test(line.Direction)) {
                    dirClass = " warning";
                  }

                  if (line.Dist === null) {
                    dirOutput += "<li class=\"direction-item line-" + i + dirClass + "\">" + dirStr + "</li>";
                  } else {
                    dirOutput += "<li class=\"direction-item sub-direction\">" + dirStr +
                      "<span class=\"stat dist\">" + $filter("number")(line.Dist, 1) + "</span>" +
                      "<span class=\"stat time\">" + line.Time + "</span>" +
                      "</li>";
                  }
                }
              }
            }
          }
          //console.log(dirOutput);
          $scope.directionsHTML = $sce.trustAsHtml(dirOutput);
        };

        $scope.processStateMileage = function (json) {
          var stateStops = "";
          var stopTolls = function (line) {
            return ($scope.route.options.inclTollData) ? wrapCell($filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(line.LTolls, 2), "numeric") + wrapCell($filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(line.TTolls, 2), "numeric") : "";
          }
          for (var s = 0; s < json.MileageReportLines.length; s++) {
            var stopLine = json.MileageReportLines[s];
            stateStops += "<tr class='state-stop-line'>" +
              wrapCell(fullAddress($scope.route.stops[s])) +
              wrapCell($filter("number")(stopLine.LMiles, 1), "numeric") +
              wrapCell($filter("number")(stopLine.TMiles, 1), "numeric") +
              wrapCell($filter("tollCostSummaryFilter")(stopLine.LCostMile, $scope.route.options.tollCurrency), "numeric") +
              wrapCell($filter("tollCostSummaryFilter")(stopLine.TCostMile, $scope.route.options.tollCurrency), "numeric") +
              wrapCell(stopLine.LHours, "numeric") +
              wrapCell(stopLine.THours, "numeric") +
              stopTolls(stopLine) +
              wrapCell($filter("number")(stopLine.LEstghg, 1), "numeric") +
              wrapCell($filter("number")(stopLine.TEstghg, 1), "numeric") +
              "</tr>";
          }
          $scope.stateTopHTML = $sce.trustAsHtml(stateStops);

          var stateData = "";
          var stateTolls = function (line) {
            return ($scope.route.options.inclTollData) ? wrapCell($filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(line.Tolls, 2), "numeric") : "";
          }
          for (var ss = 0; ss < json.StateReportLines.length; ss++) {
            var stateLine = json.StateReportLines[ss];
            if (stateLine.StCntry != null) {
              if (stateLine.StCntry.search(new RegExp("(US|Canada|Mexico|Total)", "gi")) !== -1) {
                stateData += "<tr class='state-report-line total'>";
              } else {
                stateData += "<tr class='state-report-line'>";
              }
              stateData += wrapCell(stateLine.StCntry) +
                wrapCell($filter("number")(stateLine.Total, 1), "numeric") +
                wrapCell($filter("number")(stateLine.Toll, 1), "numeric") +
                wrapCell($filter("number")(stateLine.Free, 1), "numeric") +
                wrapCell($filter("number")(stateLine.Ferry, 1), "numeric") +
                wrapCell($filter("number")(stateLine.Loaded, 1), "numeric") +
                wrapCell($filter("number")(stateLine.Empty, 1), "numeric") +
                stateTolls(stateLine) +
                "</tr>";
            }
          }
          $scope.stateListHTML = $sce.trustAsHtml(stateData);
        };

        $scope.processRoadTypes = function (json) {
          var roadOutput = "";
          if (json.ReportLines.length > 0) {
            for (var i = 0; i < json.ReportLines.length; i++) { //each line of the report
              var thisLine = json.ReportLines[i];
              if (thisLine.Stop !== null) { //origin or destination
                roadOutput += "<tr class='roadtype-line'>" +
                  wrapCell(fullAddress($scope.route.stops[i]), "long-text");
              } else {
                roadOutput += "<tr class='roadtype-line total'>" +
                  wrapCell("Total", "long-text");
              }
              roadOutput += wrapCell(thisLine.LMiles, "numeric") +
                wrapCell($filter("number")(thisLine.InterSt, 1), "numeric") +
                wrapCell($filter("number")(thisLine.InterstNoRamp, 1), "numeric") +
                wrapCell($filter("number")(thisLine.Divide, 1), "numeric") +
                wrapCell($filter("number")(thisLine.Prime, 1), "numeric") +
                wrapCell($filter("number")(thisLine.Second, 1), "numeric") +
                wrapCell($filter("number")(thisLine.Ferry, 1), "numeric") +
                wrapCell($filter("number")(thisLine.Ramp, 1), "numeric") +
                wrapCell($filter("number")(thisLine.Local, 1), "numeric") +
                wrapCell($filter("number")(thisLine.Toll, 1), "numeric") +
                "</tr>";
            }
          }
          $scope.roadTypeHTML = $sce.trustAsHtml(roadOutput);
        };

        $scope.processTollDetail = function (json) {
          var segment = "";
          for (var s = 0; s < json.SegmentLines.length; s++) {
            var segLine = json.SegmentLines[s];
            segment += "<tr class=''>" +
              wrapCell(segLine.Country, "long-text") +
              wrapCell(segLine.Road, "long-text") +
              wrapCell(segLine.TollName, "long-text") +
              wrapCell(segLine.DistanceBased, "numeric") +
              wrapCell(segLine.Pass, "numeric") +
              wrapCell($filter("number")(segLine.Flat, 1), "numeric") +
              "</tr>";
          }
          $scope.tollDetailSegmentHTML = $sce.trustAsHtml(segment);

          var summary = "";
          var total = 0;
          for (var ss = 0; ss < json.SummaryLines.length; ss++) {
            var summaryLine = json.SummaryLines[ss];
            summary += "<tr class=''>" +
              wrapCell(summaryLine.Country, "long-text") +
              wrapCell(summaryLine.TollType, "long-text") +
              wrapCell(summaryLine.TollName, "long-text") +
              wrapCell(summaryLine.TollDistance, "numeric") +
              wrapCell(summaryLine.TollsLocal, "numeric") +
              wrapCell(summaryLine.Tolls, "numeric") +
              wrapCell(summaryLine.PaymentOption, "numeric") +
              "</tr>";

            if (!isNaN(summaryLine.Tolls) && (summaryLine.TollType !== "Vignettes")) {
              total += Number(summaryLine.Tolls);
            }
          }
          summary += "<tr class=''>" + wrapCell("<b>Total</b>", "long-text", 5) + wrapCell("<b>" + total.toFixed(2) + "</b>", "numeric") + wrapCell("", "numeric");
          $scope.tollDetailSummaryHTML = $sce.trustAsHtml(summary);
        };
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/report/report.controller.js